import React from "react";
import { PeekTypography } from "@piiqtechnologies/ui-components";
export const CategoryCardTopTitle = ({ topTitle }) => {
    return (React.createElement(PeekTypography, { variant: "body1", color: "grey.400", fontWeight: "fontWeightMedium", textTransform: "uppercase" }, topTitle));
};
export default CategoryCardTopTitle;
